import { Breadcrumb } from "@gull";
import { AppContext } from "app/appContext";
import React from "react";
import { useContext } from "react";
import { Helmet } from "react-helmet";

function Dashboard() {
  const { user } = useContext(AppContext);
  return (
    <div>
      <Helmet>
        <title>Api User Dashboard </title>
      </Helmet>
      <Breadcrumb
        routeSegments={[{ name: "Api User Dashboard - " + user.name }]}
      ></Breadcrumb>
    </div>
  );
}

export default Dashboard;
